import React from 'react';
import { Avatar } from '@rneui/themed';
import { useJWT } from '@annunciate/core';
import { Title, View, Settings } from "@annunciate/ui/dist/components";
import { LogInLogOutButton } from "@annunciate/ui/dist/components/buttons/LogInLogOutButton";
export const Account = () => {
    const jwt = useJWT();
    const isLoggedIn = jwt !== undefined ? true : false;
    let initials;
    let image;
    if (jwt) {
        const i = [
            jwt.given_name ? jwt.given_name[0] : undefined,
            jwt.family_name ? jwt.family_name[0] : undefined,
        ].filter(e => !!e);
        initials = i.join('');
        image = jwt.picture;
    }
    return (React.createElement(View, { style: { flexGrow: 1, marginTop: 10 } },
        React.createElement(Title, { text: 'Account' }),
        isLoggedIn && (React.createElement(Avatar, { rounded: true, size: "xlarge", title: image ? undefined : initials, source: image ? { uri: image } : undefined })),
        React.createElement(View, { style: { marginVertical: 30, marginHorizontal: 20 } },
            React.createElement(LogInLogOutButton, null)),
        React.createElement(Settings, null)));
};
//# sourceMappingURL=Account.js.map